import type { ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';

type Props = {
  items: ArticleCardType[];
};

export default function Duo({ items }: Props) {
  const [card1, card2] = items;
  if (!card1 || !card2) return null;

  return (
    <div className="w-full bg-grey-tile">
      <div className="mx-auto flex max-w-desktop gap-6 px-4 py-10 max-sm:flex-col sm:justify-between md:py-20 desktop:px-0">
        <ArticleCard
          className="aspect-[4/5] w-[80vw] sm:mb-16 sm:w-[48%]"
          item={card1}
          name="LATEST_NEWS"
          options={{ titleSize: 'lg' }}
          pagePosition="Homepage Article Duo"
          variant="4/5-text-over"
        />
        <ArticleCard
          className="aspect-[4/5] w-[80vw] max-sm:ml-auto sm:mt-auto sm:w-2/5"
          item={card2}
          name="LATEST_NEWS"
          pagePosition="Homepage Article Duo"
          options={{ titleSize: 'lg' }}
          variant="4/5-text-over"
        />
      </div>
    </div>
  );
}
